import { render, staticRenderFns } from "./TutorialIntegracao.vue?vue&type=template&id=fe4c36c8&scoped=true"
import script from "./TutorialIntegracao.vue?vue&type=script&lang=js"
export * from "./TutorialIntegracao.vue?vue&type=script&lang=js"
import style0 from "./TutorialIntegracao.vue?vue&type=style&index=0&id=fe4c36c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4c36c8",
  null
  
)

export default component.exports